






















































import { Component, Vue, Prop ,Watch } from "vue-property-decorator";


@Component({})
export default class pluginDialog extends Vue {
  @Prop()
  plugInDialogShow!: boolean;

  @Prop()
  handleClose!: Function;

  @Prop()
  inPop!: boolean;

  @Prop()
  close!: Function;

  @Prop()
  isShopify!: boolean;

  @Prop({ type: String, default: '' })
  gateMode!: string;

  @Prop({ type: String, default: '' })
  authorizationUrl!: string;

  @Prop({ type: String, default: '' })
  recheckMessage!: string;

  get isShopifyGate() {
    return this.gateMode === 'enable' || this.gateMode === 'authorize' || this.gateMode === 'reauth' || this.gateMode === 'retry';
  }

  get shortGate() {
    return this.gateMode === 'reauth' || this.gateMode === 'retry';
  }

  get dialogTitle() {
    if (this.gateMode === 'reauth') {
      return this.$tx('form.install.gateTitleReauth', '发布前需重新授权');
    }
    if (this.gateMode === 'retry') {
      return this.$tx('form.install.gateTitleRetry', '暂时无法确认主题嵌入');
    }
    if (this.isShopifyGate) {
      return this.$tx('form.install.gateTitle', '发布前需开启主题嵌入');
    }
    return this.$tx('form.install.title', '安装订阅工具');
  }

  get shopifyBody() {
    if (this.gateMode === 'reauth') {
      return this.$tx('form.install.gateReauth', '店铺应用未安装或授权已失效。未安装时，弹窗的曝光和提交无法统计，也获取不到人群信息。请先重新授权安装。');
    }
    if (this.gateMode === 'retry') {
      return this.$tx('form.install.gateRetry', '暂时无法确认主题嵌入是否已开启。未开启时，弹窗的曝光和提交无法统计，也获取不到人群信息。请稍后重试。');
    }
    if (this.gateMode === 'authorize') {
      return this.$tx('form.install.gateBody', 'Shopify 已下线脚本嵌入，改为应用主题嵌入。目前店铺的 CartSee 主题嵌入未开启，已发布的弹窗无法在店铺展示。');
    }
    return this.$tx('form.install.gateBodyEnable', 'Shopify 已下线脚本嵌入，改为应用主题嵌入。目前店铺的 CartSee 主题嵌入未开启，已发布的弹窗无法在店铺展示。请点击「前往开启」，在当前正在使用的主题里打开应用嵌入并点击 Save。');
  }

  public openAuthorization() {
    if (!this.authorizationUrl) {
      this.$message.error(this.$tx('form.install.authUrlMissing', '暂时无法获取 Shopify 授权地址，请稍后重试'));
      return;
    }
    window.open(this.authorizationUrl);
  }

  public getInstallJumpUrl() {
    const companyInfo = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    if (companyInfo.shop) {
      if (companyInfo.shop.includes('shopify')) {
        return `https://${companyInfo.shop}/admin/themes/current/editor?context=apps&activateAppId=3cb8722a-4436-4e4c-88af-b33e3fe7857a/onsite-javascript`;
      } else if (companyInfo.shop.includes('shopline')) {
        return `https://${companyInfo.shop}/admin/theme/editor/editing/Home?templateName=templates%2Findex.json&activateAppId=5d87df78-5746-4440-b2ec-0336110c2dc6%2Fonsite-javascript`;
      }
    }
    if (this.isShopify) {
      return `https://${companyInfo.shopPre}.myshopify.com/admin/themes/current/editor?context=apps&activateAppId=3cb8722a-4436-4e4c-88af-b33e3fe7857a/onsite-javascript`;
    } else {
      return `https://${companyInfo.shopPre}.myshopline.com/admin/theme/editor/editing/Home?templateName=templates%2Findex.json&activateAppId=5d87df78-5746-4440-b2ec-0336110c2dc6%2Fonsite-javascript`;
    }
    return ``;
  }
  get installHint2() {
    const platform = this.getType() == 'shopify' ? 'Shopify' : 'Shopline';
    return this.$tx('form.install.hint2', '您需要在 {{platform}} 中启用您的应用嵌入：', { platform });
  }
  public getType() {
    const companyInfo = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    if (companyInfo.shop) {
      if (companyInfo.shop.includes('shopify')) {
        return `shopify`;
      } else if (companyInfo.shop.includes('shopline')) {
        return `shopline`;
      }
    }
    if (this.isShopify) {
      return `shopify`;
    } else {
      return `shopline`;
    }
    return ``;

  }
  public jumpToInstallUrl() {
    window.open(this.getInstallJumpUrl());
  }
}
